'use strict'

import React,{Component} from 'react';

import IssueDetailsReport from '../log/IssueDetailsReport.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

export default class IssueReportPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state={disabled:false};
  }

  publish(event) {
    this.setState({disabled:true});
    this.props.publish(event);
  }

  render() {
    let labels=translations.getTranslation(this.props).report;
    return (
      <div style={{display:"flex", justifyContent:"center"}}>
        <div style={{fontFamily: "Verdana, sans-serif", padding:5}}>
          <IssueDetailsReport
            {...this.props}
            type="preview"
            timestamp={new Date()}
            date={new Date()}
            issue={this.props.issue}
          />

          <div style={{paddingTop:35}}>
            <input onClick={this.props.cancel} type="button" className="cancel" value={labels.cancel}/>
            <input disabled={this.state.disabled} onClick={this.publish.bind(this)} type="button" className="save" value={!this.state.disabled ? labels.publishReport : labels.publishInProgress}/>
          </div>
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./views/change/IssueReportPreview.jsx